import { Box, Button, Stack, Typography } from '@mui/material';
import CustomContainer from '../../components/CustomContainer';
import PageHeader from '../../components/PageHeader';
import AppCard from '../../components/ui/AppCard';
import Eyebrow from '../../components/ui/Eyebrow';
import EmptyState from '../../components/EmptyState';
import { copyToClipBoard } from '../../utils/functions';
import { useAuth } from '../../contexts/AuthProvider';
import { isCatalogEnabled } from '../../components/layout/Header/partnerNav';
import { FaArrowUpRightFromSquare, FaCopy } from 'react-icons/fa6';

export default function MyCatalog() {
    const { user } = useAuth();
    const slug = user?.catalog_slug || user?.slug;
    const hasCatalog = isCatalogEnabled(user) && Boolean(slug);
    const origin = typeof window !== 'undefined' ? window.location.origin : 'https://inovartgold.com.br';
    const catalogUrl = hasCatalog ? `${origin}/catalogo-parceiro/${slug}` : '';

    return (
        <CustomContainer>
            <Box sx={styles.section}>
                <PageHeader title="Meu catálogo" crumbs={['Meu catálogo']} />
                {hasCatalog ? (
                    <AppCard>
                        <Eyebrow>Link público</Eyebrow>
                        <Typography variant="h4" sx={{ mt: 1, textAlign: 'left', textWrap: 'balance' }}>
                            O catálogo que seus clientes veem
                        </Typography>
                        <Typography sx={styles.lede}>
                            Envie este endereço. Eles encontram suas joias sem entrar na área do parceiro.
                        </Typography>
                        <Box sx={styles.urlFrame}>
                            <Typography sx={styles.url} title={catalogUrl}>
                                {catalogUrl.replace(/^https:\/\//, '')}
                            </Typography>
                        </Box>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} sx={{ mt: 3 }}>
                            <Button
                                variant="contained"
                                color="secondary"
                                startIcon={<FaCopy size={14} />}
                                onClick={() => copyToClipBoard(catalogUrl, 'Link de catálogo')}
                            >
                                Copiar link
                            </Button>
                            <Button
                                variant="outlined"
                                color="primary"
                                startIcon={<FaArrowUpRightFromSquare size={14} />}
                                href={catalogUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Abrir catálogo
                            </Button>
                        </Stack>
                    </AppCard>
                ) : (
                    <AppCard>
                        <EmptyState
                            title="Catálogo ainda não liberado"
                            description="Quando a Inovart ativar o seu catálogo de parceiro, o link para compartilhar aparece aqui."
                        />
                    </AppCard>
                )}
            </Box>
        </CustomContainer>
    );
}

const styles = {
    section: {
        my: 4,
        minHeight: '60vh',
    },
    lede: {
        mt: 1.5,
        mb: 3,
        color: 'text.secondary',
        textAlign: 'left',
        maxWidth: 520,
    },
    urlFrame: {
        px: 2,
        py: 1.5,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        bgcolor: 'background.default',
    },
    url: {
        fontFamily: 'Montserrat',
        fontSize: { xs: '0.8125rem', md: '0.9375rem' },
        fontWeight: 600,
        fontVariantNumeric: 'tabular-nums',
        letterSpacing: '0.01em',
        color: 'text.primary',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
};
